<template>
    <div class="page-table tabStyle scrollable mainDiv" id="affix-container">
        <div class="card-base baslikBg animated fadeInUp">{{$t("src.views.apps.urun.malzeme.duzenleme.baslikH1")}}</div>
        <el-row :gutter="10">
            <el-form status-icon :model="urunMalzeme" :rules="rulesUrunMalzeme" ref="urunMalzeme"
                     class="demo-ruleForm">
                <el-col :lg="18" :md="18" :sm="24" :xs="24">
                    <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft">
                        <el-row>
                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.baslik")'
                                              prop="baslik">:
                                    <el-input size="small"
                                            v-model="urunMalzeme.baslik"
                                            :placeholder='$t("src.views.apps.sayfa.tanimlama.baslikPlace")'></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col v-if="$store.state.dilDurum" :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.dil.de.baslik")'
                                              prop="dil.de.baslik">:
                                    <el-input size="small"
                                            v-model="urunMalzeme.dil.de.baslik"
                                            :placeholder='$t("src.views.apps.sayfa.tanimlama.baslikPlace")'></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                    <!--<el-collapse style="margin-top: 10px" v-model="activeCollapse">-->
                    <!--<el-collapse-item title="Katogori Ayarları" name="4">-->
                    <!--<el-row>-->
                    <!--<el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">-->
                    <!--<el-form-item prop="kategoriList">-->
                    <!--<el-transfer-->
                    <!--style="text-align: left; display: inline-block"-->
                    <!--v-model="urunMalzeme.kategori"-->
                    <!--filterable-->
                    <!--:titles="['Kategori Listesi', 'Seçilen Kategoriler']"-->
                    <!--:format="{-->
                    <!--noChecked: '${total}',-->
                    <!--hasChecked: '${checked}/${total}'-->
                    <!--}"-->
                    <!--@change="kategoriChange"-->
                    <!--:data="kategoriListesi">-->
                    <!--</el-transfer>-->
                    <!--</el-form-item>-->
                    <!--</el-col>-->
                    <!--</el-row>-->
                    <!--</el-collapse-item>-->
                    <!--</el-collapse>-->
                </el-col>
                <el-col :lg="6" :md="6" :sm="24" :xs="24">
                    <el-collapse class="yanForm animated fadeInUp delay-1s" v-model="activeCollapse">
                        <el-collapse-item name="1" :title='$t("src.views.apps.urun.malzeme.tanimlama.durum")'>
                            <el-row>
                                <el-button size="mini" class="onayBtn"
                                           v-on:click="malzemeGuncelle('urunMalzeme')"
                                           type="primary">
                                    {{$t('src.views.apps.sayfa.guncelleme.sayfaguncelle')}}
                                </el-button>
                                <el-button
                                        size="mini" @click="$router.go(-1)"
                                        class="onayBtn">
                                    Vazgeç
                                </el-button>
                            </el-row>
                        </el-collapse-item>
                        <el-collapse-item :title='$t("src.views.apps.urun.malzeme.tanimlama.yapiskan")' name="2">
                            <el-row>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item prop="yapiskan">
                                        <el-switch
                                                v-model="urunMalzeme.yapiskan"
                                                active-value="1"
                                                inactive-value="0"
                                                active-text="Sabitle"
                                                inactive-text="Sabitleme">
                                        </el-switch>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-collapse-item>
                        <el-collapse-item :title='$t("src.views.apps.urun.malzeme.tanimlama.konum")' name="3">
                            <el-row>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item prop="konum">
                                        <el-button type="primary" size="mini" @click="dialogKonum = true">
                                            {{this.konumText}}
                                        </el-button>
                                        &nbsp;
                                        <img v-if="urunMalzeme.konum === '0'" style="float: right"
                                             src="../../../../assets/images/13.png" width="60%" height="60%">
                                        <img v-if="urunMalzeme.konum === '1'" style="float: right"
                                             src="../../../../assets/images/14.png" width="60%" height="60%">
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-collapse-item>
                    </el-collapse>
                </el-col>
            </el-form>
            <el-dialog
                    title="Malzeme Konumu"
                    :visible.sync="dialogKonum"
                    width="50%">
                <el-row>
                    <el-col :span="12">
                        <el-radio v-model="urunMalzeme.konum" label="0" @change="changeKonum('0')">
                            <img src="../../../../assets/images/13.png" alt="Alt" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                    <el-col :span="12">
                        <el-radio v-model="urunMalzeme.konum" label="1" @change="changeKonum('1')">
                            <img src="../../../../assets/images/14.png" alt="Sağ" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                </el-row>
            </el-dialog>
        </el-row>
    </div>
</template>

<script>
    import JQuery from 'jquery';
    import urunService from '../../../../WSProvider/UrunService'
    import notification from '../../../../notification'

    let $ = JQuery;
    let base64 = require('base64_js');
    let userDataSortas = "";
    export default {
        name: "MalzemeDuzenle",
        mounted() {

            this.getKategoriListesi();
            this.updateMalzemeKodu = this.$store.state.updateKodu;
            this.getMalzemeDetay(this.updateMalzemeKodu);
        },
        data() {
            return {
                updateMalzemeKodu: '',
                malzemeDetayKlon: [],
                updateData: [],
                updateDataDE: [],

                dialogKonum: false,
                konumText: "Seç",
                kategoriListesi: [],
                activeCollapse: ['1', '2', '3', '4', '5'],
                visibleSil: false,
                urunMalzeme: {
                    baslik: '',
                    kategoriList: [],
                    yapiskan: '',
                    durum: '',
                    konum: '',
                    dil: {
                        de: {
                            baslik: '',
                        }
                    }
                },
                rulesUrunMalzeme: {
                    baslik: [{
                        required: true,
                        message: " ",
                        trigger: 'change'
                    }],
                },
            }
        },
        methods: {
            kategoriChange(value) {
                this.urunMalzeme.kategoriList = value;
            },
            getKategoriListesi() {
                let self = this;
                urunService.kategoriList().then((response) => {
                    if (response.status === 200) {
                        response.data.forEach(function (e) {
                            self.kategoriListesi.push({
                                key: e.urunKategoriKodu,
                                label: e.baslik,
                            });
                        })
                    } else {
                        notification.Status(response.status, this)
                    }
                })
            },
            getMalzemeDetay() {
                urunService.malzemeDetay(this.updateMalzemeKodu).then((response) => {
                    if (response.status === 200) {
                        for (var key in response.data) {
                            this.urunMalzeme[key] = response.data[key];
                            this.malzemeDetayKlon = JSON.stringify(response.data);
                        }
                    } else {
                        notification.Status(response.status, this)
                    }
                })
            },
            malzemeGuncelle(formName) {
                var dizi = [];
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        for (var key in JSON.parse(this.malzemeDetayKlon)) {
                            if (key !== 'dil') {
                                if (JSON.parse(this.malzemeDetayKlon)[key] !== this.urunMalzeme[key]) {
                                    if (this.urunMalzeme[key]) {
                                        var item = {
                                            type: key,
                                            value: this.urunMalzeme[key]
                                        };
                                        this.updateData.push(item);
                                    }
                                }
                            } else if (key === 'dil') {
                                for (var keyDil in JSON.parse(this.malzemeDetayKlon).dil.de) {
                                    if (JSON.parse(this.malzemeDetayKlon).dil.de[keyDil] !== this.urunMalzeme.dil.de[keyDil]) {
                                        if (this.urunMalzeme.dil.de[keyDil]) {
                                            var itemDe = {
                                                type: keyDil,
                                                value: this.urunMalzeme.dil.de[keyDil]
                                            };
                                            this.updateDataDE.push(itemDe);
                                        }
                                    }
                                }
                                if (this.updateDataDE.length !== 0) {
                                    this.updateData.push({
                                        type: "dil",
                                        value: {
                                            de: this.updateDataDE
                                        }
                                    })
                                }

                            }
                        }

                        urunService.malzemeGuncelle(this.updateMalzemeKodu, this.updateData).then((response) => {
                            if (response.status === 200) {
                                notification.Status('success', this, 'Malzeme başarıyla güncellendi.');
                                this.$refs[formName].resetFields();
                                $('.el-upload-list__item-delete').click();
                                history.back();
                            }
                            if (response.status === 230) {
                                notification.Status('warning', this, 'Bu bilgiler ile kayıtlı bir malzeme zaten mevcut');

                            } else {
                                notification.Status(response.status, this)
                            }
                        })
                    }
                })
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                $('.el-upload-list__item-delete').click();
                this.visibleSil = false;
            },
            changeKonum(konum) {
                this.dialogKonum = false;
                this.konumText = "Değiştir";
                switch (konum) {
                    case '0' :
                        notification.Status('success', this, 'Malzeme konumu "Tab" olarak seçildi.');
                        break;
                    case '1' :
                        notification.Status('success', this, 'Malzeme konumu "Sağ" olarak seçildi.');
                        break;
                }

            }

        }
    }
</script>
<style scoped>
    #affix-container.tabStyle {
        position: relative;
        padding-left: 55px;
        left: -30px;
    }

    .cop {
        color: #ec205f;
        position: relative;
        float: right;
        right: 15px;
        bottom: 10px;
        font-size: 20px;
    }
</style>
<style lang="scss" scoped>
    @import '../../../../assets/scss/_variables';

    .aciklamaSpan {
        position: absolute;
        top: 25px;
    }

    .page-table {
        &.overflow {
            overflow: hidden;
        }

        .table-box {
            overflow: hidden;
        }
    }

    .el-form-item {
        font-weight: bold;
    }

</style>